import { CuriosityNamespaceType, useCuriosityTranslationLoader } from '@procureai/curiosity-ui-mui';
import { isNotNil } from 'ramda';
import { MutableRefObject, useEffect } from 'react';
import { KeepStateOptions, useController, useFormContext } from 'react-hook-form';

import { ContractDemandRequestItem } from '../ContractDemandRequestLineItems/ContractDemandRequestItemForm.schema.ts';

const keepStateOptions: KeepStateOptions = {
  keepErrors: true,
  keepDirty: true,
  keepTouched: true,
};

export interface UseContractDemandRequestLinePrefillProps {
  changeRef: MutableRefObject<boolean>;
  hasBeenChangedByUser: () => boolean | undefined;
}

export const useContractDemandRequestLinePrefill = ({
  changeRef,
  hasBeenChangedByUser,
}: UseContractDemandRequestLinePrefillProps) => {
  const { load } = useCuriosityTranslationLoader();

  const form = useFormContext<ContractDemandRequestItem>();

  const { field } = useController({
    control: form.control,
    name: 'commodityId',
  });
  const value = field.value;

  useEffect(() => {
    if (hasBeenChangedByUser()) {
      changeRef.current = false;
      if (isNotNil(value)) {
        (async () => {
          const translation = await load(CuriosityNamespaceType.COMMODITY, value);
          if (translation) {
            form.reset(
              (prev) => ({
                ...prev,
                title: translation.entity.title ?? '',
                description: translation.entity.description ?? '',
                commodityGroupId: translation.entity.commodityGroupId ?? null,
                unitId: translation.entity.unitId,
                // reset organization if commodity changes
                organizationId: undefined as any,
              }),
              keepStateOptions,
            );
          }
        })();
      } else {
        form.reset(
          (prev) => ({
            ...prev,
            organizationId: undefined as any,
          }),
          keepStateOptions,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
};
